<script setup lang="ts">
import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'

import { LoginForm } from '@collector/desktop-feature-login-form'
import {
  ModalContainer,
  provideAppRootElementSelector,
  startLoader,
  stopLoader,
  useModalStack,
} from '@collector/shared-ui'
import {
  provideRequestUrl,
  provideSportsApiClient,
} from '@collector/shared-ui-domain'
import { useEventListener } from '@vueuse/core'

import Notification from './components/Notification.vue'
import { appRootElementSelector } from './consts'
import { Env } from './envs'
import { sportsApiClient } from './globalState/sportsApiClient'
import { useAuth } from './globalState/userAuth/useAuth'

// composables
const { authInitialized, loggedIn, initAuth, logIn, refreshAuth, requestUrl } =
  useAuth()
const route = useRoute()
useModalStack() // provide modal stack

// computed
const routeKey = computed(() => route.name?.toString().split('.')[0])

// init
initAuth()
watch(authInitialized, (value) => value && stopLoader(), { immediate: true })

provideSportsApiClient(sportsApiClient)
provideAppRootElementSelector(appRootElementSelector)
provideRequestUrl(requestUrl)

useEventListener(window, 'online', refreshAuth)
</script>

<template>
  <div class="min-h-screen max-w-screen">
    <Notification />
    <template v-if="authInitialized">
      <RouterView
        v-if="loggedIn"
        :key="routeKey"
        v-slot="{ Component }"
      >
        <Suspense @pending="startLoader">
          <component :is="Component" />
        </Suspense>
      </RouterView>
      <LoginForm
        v-else
        :apiUrl="Env.VITE_SPORTS_API_URL"
        :appMode="Env.VITE_APP_MODE"
        @logIn="logIn"
      />
    </template>
  </div>

  <ModalContainer />
</template>
